module.exports = __webpack_public_path__ + "img/scb-logo.19132ad4.svg";